<template>
  <div class="review">
    <v-btn
      text
      rounded
      color="primary"
      @click="toggleReviewDialog()"
      >
      <div class="font-weight-bold text-none pr-1">Vurder besøket</div>
      <v-icon>fxt-star-filled</v-icon>
    </v-btn>
    <common-dialog
      v-if="showDialog"
      icon="fxt-star"
      @closeDialog="toggleReviewDialog()"
      :show="showDialog"
      :layout="layout"
      title="Vurder besøket"
    >
      <div v-if="!hasSentReview">
          <p class="review__title">
          Gi din vurdering av besøket hos {{ orderDetailed.salonInformation.siteName }} {{ $moment(orderDetailed.appointmentDate).format("dddd D. MMMM") }}
          </p>

          <p class="review__description">
            Kjære kunde. Vi vil gjerne høre fra deg, og vi setter stor pris på om du vil gi oss en vurdering.
          </p>

          <p class="review__instructions">
            Velg antall stjerner du ønsker å gi
          </p>

          <div class="d-flex justify-between my-4">
            <v-icon size="48" color="#579FA7" @click="rating = 1">fxt-star{{ rating >= 1 ? '-filled' : '' }}</v-icon>
            <v-icon size="48" color="#579FA7" @click="rating = 2">fxt-star{{ rating >= 2 ? '-filled' : '' }}</v-icon>
            <v-icon size="48" color="#579FA7" @click="rating = 3">fxt-star{{ rating >= 3 ? '-filled' : '' }}</v-icon>
            <v-icon size="48" color="#579FA7" @click="rating = 4">fxt-star{{ rating >= 4 ? '-filled' : '' }}</v-icon>
            <v-icon size="48" color="#579FA7" @click="rating = 5">fxt-star{{ rating >= 5 ? '-filled' : '' }}</v-icon>
          </div>

          <p class="review__instructions">
            Legg til en kommentar (frivillig)
          </p>

          <!-- Comment Input -->
          <v-text-field
              v-model="comment"
              class="profile__container--content__input"
              @input="setComment"
          ></v-text-field>

          <v-checkbox
              v-model="checkbox1"
              readonly
              on-icon="fxt-radio-on"
              off-icon="fxt-radio-off"
              hide-details
              @click="toggleCheckbox(true)"
              color="primary"
          >
            <template v-slot:label>
              <p class="review__checkbox-text">Jeg godkjenner at fornavnet mitt og min tilbakemelding kan bli vist på salongens nettside og på fixit.no.</p>
            </template>
          </v-checkbox>

          <v-checkbox
              v-model="checkbox2"
              readonly
              on-icon="fxt-radio-on"
              off-icon="fxt-radio-off"
              hide-details
              @click="toggleCheckbox(false)"
              color="primary"
          >
            <template v-slot:label>
              <p class="review__checkbox-text">Jeg ønsker at denne tilbakemeldingen kun skal være tilgjengelig for intern bruk i salongen.</p>
            </template>
          </v-checkbox>

          <v-btn
          class="mt-8"
          rounded
          width="100%"
          :disabled="rating === 0"
          color="primary"
          :loading="loading"
          @click="sendReview()"
          >
          <div class="font-weight-bold text-none pr-1">Send inn</div>
        </v-btn>
      </div>
      <div v-else>
        <div class="d-flex flex-column justify-center text-center my-10">
          <v-icon size="96" color="primary" class="mb-10">fxt-star-filled</v-icon>
          <p class="review__thank-you mb-8">Takk for din vurdering</p>
          <p class="review__thank-you--description">Dette hjelper oss på å bli bedre!</p>
        </div>
      </div>
    </common-dialog>
  </div>
</template>

<script>
import { CommonDialog } from "../../../../Common/CommonComponents";
import ProfileSvc from '../../../../../services/profile-svc';
let profileSvc = null;
export default {
  components: { CommonDialog },
  props: {
    layout: {
      required: false,
      default: null,
      type: String,
    },
    orderDetailed: {
      required: true
    },
  },
  data: () => ({
    loading: false,
    showDialog: false,
    rating: 0,
    comment: '',
    checkbox1: true,
    checkbox2: false,
    hasSentReview: false
  }),
  computed: {
    siteId() {
      return this.layout == "portal"
        ? this.$route.params.siteId
        : this.$route.query.siteId;
    },
    portalUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_URL
        : this.$config.VUE_APP_FIXIT_NO_URL
        ? this.$config.VUE_APP_FIXIT_NO_URL
        : process.env.VUE_APP_FIXIT_NO_URL;
    },
    profileUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_PROFILE_URL
        : this.$config.VUE_APP_FIXIT_PROFILE_URL
        ? this.$config.VUE_APP_FIXIT_PROFILE_URL
        : process.env.VUE_APP_FIXIT_PROFILE_URL;
    },
    bookingApi() {
        return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
    },
  },
  methods: {
    async sendReview() {
      this.loading = true;
      let success = await profileSvc.SendReview({
        siteId: this.siteId,
        rating: this.rating,
        comment: this.comment,
        isPublic: this.checkbox1, //is public
        appointmentId: this.orderDetailed.appointmentId
      })
      
      if (success) {
        this.hasSentReview = true;
        this.$emit('sentReview')
        setTimeout( () => this.showDialog = false, 3000);
      }
      this.loading = false;
    },
    toggleReviewDialog() {
      this.showDialog = !this.showDialog;

      if (!this.showDialog) {
        this.resetData()
      }
    },
    resetData() {
      this.comment = "";
      this.rating = 0;
      this.checkbox1 = true;
      this.checkbox2 = false;
      this.hasSentReview = false;
    },
    setComment(comment) {
      this.comment = comment
    },
    toggleCheckbox(consent) {
      if (consent) {
        this.checkbox1 = true
        this.checkbox2 = false
      } else {
        this.checkbox1 = false
        this.checkbox2 = true
      }
    }
  },
  async created() {
      profileSvc = await ProfileSvc(this.$axios);
  },
  beforeDestroy() {
    profileSvc = null
  }
}
</script>

<style scoped lang="scss">
.review {
  &__title {
    color: var(--v-primary-base);
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }
  
  &__description {
    color: var(--v-primary-base);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
  
  &__instructions {
    margin-bottom: 0px;
    color: var(--v-primary-base);
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
  }
  &__checkbox-text {
    margin-bottom: 0px;
    color: var(--v-primary-base);
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
  }
  &__thank-you {
    color: var(--v-primary-base);
    font-size: 24px;
    font-weight: 400;
    line-height: 27.96px;
  }
  &__thank-you--description {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: 300;
    line-height: 23.3px;
  }
}

</style>
